// @ts-ignore missing types
import React from 'react';
import brandonTextRegular from '../../assets/fonts/brandon-text-regular-v2.woff2';
import brandonTextMedium from '../../assets/fonts/brandon-text-medium-v2.woff2';
import chronicleLight from '../../assets/fonts/chronicle-light-v2.woff2';
import chronicleRoman from '../../assets/fonts/chronicle-roman-v2.woff2';

export const fontFamilyBrandonMedium = 'brandon-text-medium';
export const fontFamilyBrandonRegular = 'brandon-text-regular';
export const fontFamilyChronicleLight = 'chron-icle-light';
export const fontFamilyChronicleRoman = 'chron-icle-roman';

const buildFontUrl = (staticHost: string, fontName: string) =>
    `${staticHost.replace(/\/$/, '')}${fontName.replace('//', '/')}`;

const fontsStyle = (staticHost: string) => `
    @font-face {
        font-family: '${fontFamilyBrandonMedium}';
        font-display: swap;
        src: url('${buildFontUrl(staticHost, brandonTextMedium)}') format('woff2');
        font-weight: 550;
        font-style: normal;
    }
    @font-face {
        font-family: '${fontFamilyBrandonRegular}';
        font-display: swap;
        src: url('${buildFontUrl(staticHost, brandonTextRegular)}') format('woff2');
        font-weight: 400;
        font-style: normal;
    }
    @font-face {
        font-family: '${fontFamilyChronicleLight}';
        font-display: swap;
        src: url('${buildFontUrl(staticHost, chronicleLight)}') format('woff2');
    }
    @font-face {
        font-family: '${fontFamilyChronicleRoman}';
        font-display: swap;
        src: url('${buildFontUrl(staticHost, chronicleRoman)}') format('woff2');
    }
`;

export const FontStyle: React.FC<{ staticHost: string }> = ({ staticHost }) => (
    <style dangerouslySetInnerHTML={{ __html: fontsStyle(staticHost) }} />
);

export default fontsStyle;
